import {Button, Card, Form, Spin} from 'antd';
import React from "react";
import {getFormFieldByType, sanitizeFieldName} from "../../util/methods";
import SubListPageSetting from "../../components/SubList/subListPageSetting";

class Create extends React.Component {

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    // console.log(this.props)
  }

  componentWillReceiveProps(nextProps, nextContext) {
    // console.log(nextProps.data, this.props.data)
    if (nextProps && nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      // console.log(nextProps.data);
      const {pageName} = nextProps.data;
      this.pageChangeHandle(pageName);
    }
  }

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      // console.log(values);
      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  pageChangeHandle = (e) => {
    const {getPageFilterData} = this.props;
    if (e && getPageFilterData) {
      getPageFilterData(e);
    }
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, title, resource, form, pageData} = this.props;
    // console.log(pageData)
    // console.log(data)
    const pageSelectableData = [];
    pageData && Object.keys(pageData).forEach(key => {
      const val = pageData[key];
      if (key !== '_id' && val && !val.required && val.options && !val.options.hidden && !val.options.notVisible) {
        // console.log(key, pageData[key]);
        pageSelectableData.push({_id: key, name: key});
      }
    });
    // console.log(resource)

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(filters).map((item, ix) => {
              if (filters[item].type === 'Array' && filters[item].schema && item === 'settings') {
                return <SubListPageSetting key={item} item={filters[item]} form={form} data={data[item]}
                                           title={title}
                                           resource={resource} selectData={pageSelectableData} pageData={pageData}/>
              } else {
                return getFormFieldByType(filters, item, getFieldDecorator, data, {
                  title: title,
                  resource,
                  onChange: this.pageChangeHandle
                })
              }
            })}

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
